<h1 mat-dialog-title>Request Review</h1>
<div mat-dialog-content>
    <div>
        Send SMS to {{data.customer.name}} on <span [apPhone]="data.customer.phone">{{data.customer.phone | phone}}</span>
    </div>

    <mat-form-field class="sms-text" appearance="outline">
        <textarea [(ngModel)]="body" matTextareaAutosize matInput placeholder="SMS to send"></textarea>
    </mat-form-field>
</div>
<div mat-dialog-actions>
    <button mat-dialog-close mat-button>No Thanks</button>
    <button mat-button cdkFocusInitial (click)="confirm()" [disabled]="hasConfirmed">Confirm</button>
</div>